import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { GetPositionById } from "../../services/PositionService";
import { GetUserProfileById } from "../../services/ProfileService";
import { GetMessageById } from "../../services/TextMessageService";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  GetMessagingMediaFileById,
  GetMessagingMediaFilesEntityId,
} from "../../services/MessagingMediaService";

interface MessageProps {
  id: string;
  //messageTypes: number;
}

// Define the Message component
const Message: React.FC<MessageProps> = ({ id }) => {
  const [message, setMessage] = useState(null);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState("");
  const [positionId, setPositionId] = useState(null);
  const [position, setPosition] = useState("");
  const [messageType, setMessageType] = useState(0);
  const [data, setData] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  async function GetPositionByIdAsync() {
    return await GetPositionById(positionId).then((p) => {
      setPosition(p.data.name);
    });
  }

  async function GetUserProfileAsync() {
    return await GetUserProfileById(userId).then((p) => {
      setUser(p.data.data.firstName + " " + p.data.data.lastName);
    });
  }
  async function GetMessageByIdAsync() {
    return await GetMessageById(id);
  }
  async function GetMessagingMediaFilesEntityIdAsync() {
    if (data.id) {
      console.log("id", data.id);

      await GetMessagingMediaFilesEntityId(data.id).then((p) => {
        if (p.data.data) {
          setFile(p?.data?.data[0]);
        }
      });
    }
  }
  useEffect(() => {
    console.log("mdta2", id);

    GetMessageByIdAsync().then((p) => {
      console.log("mdta", p.data);
      setData(p.data.data);
      setMessage(p.data.data.text);
      setUserId(p.data.data.userId);
      setPositionId(p.data.data.positionId);
      setMessageType(p.data.data.messageType);
    });
  }, []);
  useEffect(() => {
    if (positionId) {
      GetPositionByIdAsync();
    }
  }, [positionId]);
  useEffect(() => {
    if (userId) {
      GetUserProfileAsync();
    }
  }, [userId]);

  useEffect(() => {
    if (data) {
      if (data.messageType === 2) {
        GetMessagingMediaFilesEntityIdAsync();
      }
    }
  }, [data]);

  async function handleDownload(id: any, fileName: any) {
    await GetMessagingMediaFileById(id)
      .then((response) => {
        //console.log(response);

        // Create a blob object from the response
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // Handle download error
      });
  }

  return (
    <>
      <div style={{ color: "gray", fontSize: "0.75rem" }}>
        [{position}]({user})
      </div>
      {messageType === 2 ? (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => handleDownload(file?.id, file?.name)}
        >
          {file?.name}

          <IconButton
            //variant="outlined"
            //style={{ height: "100px", width: "100px" }}
            component="span"
            className="iran"
          >
            <AttachFileIcon />
          </IconButton>
        </div>
      ) : (
        <>
          <div style={{ fontSize: "1.3rem" }}>{message}</div>{" "}
        </>
      )}
    </>
  );
};
export default Message;
